<template>
    <v-layout
        row
        wrap
    >
        <!-- Edit Return -->
        <v-flex
            xs6
            offset-xs6
        >
            <v-btn
                class="my-0"
                color="success"
                block
                :to="{name: 'editReturn', params: {id: returnId}}"
            >
                <v-icon
                    left
                    size="20"
                >
                    fas fa-edit
                </v-icon>
                Edit
            </v-btn>
        </v-flex>
    </v-layout>
</template>

<script>
export default {
    props: {
        returnId: {
            type: String,
            required: true
        }
    }
}
</script>

<style>

</style>
